import React from 'react';
import { X } from 'lucide-react';
import { Button } from '../../catalyst/button';

// Custom Modal component that provides consistent layout
export const Modal = ({ isOpen, onClose, title, children, size = 'lg' }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
    '2xl': 'max-w-6xl',
    '3xl': 'max-w-7xl',
    '4xl': 'max-w-[90rem]',
    '5xl': 'max-w-[100rem]'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />
      
      {/* Modal */}
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className={`relative bg-white rounded-lg shadow-xl ${sizeClasses[size]} w-full max-h-[90vh] overflow-hidden`}>
          {/* Header */}
          <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10">
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          
          {/* Content - Scrollable */}
          <div className="overflow-y-auto" style={{ maxHeight: 'calc(90vh - 8rem)' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

// Modal Body with padding
export const ModalBody = ({ children, className = '' }) => {
  return (
    <div className={`px-6 py-4 ${className}`}>
      {children}
    </div>
  );
};

// Modal Actions for buttons
export const ModalActions = ({ children, className = '' }) => {
  return (
    <div className={`sticky bottom-0 bg-gray-50 px-6 py-4 border-t border-gray-200 ${className}`}>
      {children}
    </div>
  );
};